import axios from 'axios'

export default function Loginer(user, pw, callback) {

    axios.post('/api/auth/login', {
        idName: user,
        password: pw
    })

    .then(res => {

        if (res.status === 200) {

            localStorage.setItem('key', res.data.info)

            headerInjection(res.data.info)
            
            callback({
                message : 'Welcome Back!'
            })
            
        } else {
            callback({
                message : 'Fail to Sign-in'
            })
        }

    })

    .catch(err => {
        callback({
            message : 'Error'
        })
    })
        		
}


function headerInjection(key) {

    axios.interceptors.request.use( config => {

        config.headers.Authorization = key
        return config

    	}, (error) => { return Promise.reject(error) }
    
    )

} 



// WEBPACK FOOTER //
// ./src/controller/Loginer.js